import React from 'react';

import { getShareLink, ShareType } from '@repo/editor/src/utils/share';
import EnvelopeIcon from '@repo/ui/components/Icon/EnvelopeIcon';
import WhatsappIcon from '@repo/ui/components/Icon/WhatsappIcon';

import LinkButton from 'components/LinkButton/LinkButton';
import {
  inviteShareIconOptions,
  inviteShareMobileIconOptions,
} from 'components/Subscription/Invites/config';
import {
  inviteShareEmailButtonTheme,
  inviteShareMobileButtonTheme,
} from 'components/Subscription/Invites/theme';
import { InviteShareButtonProps } from 'components/Subscription/Invites/types';
import { LayoutSwitch } from 'styles/queries';

const InviteShareEmailButton: React.FC<InviteShareButtonProps> = (props) => {
  return (
    <LayoutSwitch
      desktopProps={{
        theme: inviteShareEmailButtonTheme,
        width: '53px',
        icon: { ...inviteShareIconOptions, component: EnvelopeIcon },
      }}
      mobileBreakpoint="tabletAndUp"
      mobileProps={{
        theme: {
          ...inviteShareEmailButtonTheme,
          ...inviteShareMobileButtonTheme,
        },
        width: '30px',
        icon: { ...inviteShareMobileIconOptions, component: EnvelopeIcon },
      }}
    >
      <LinkButton
        href={getShareLink(ShareType.Mail, props.inviteLink, {
          mailSubject: props.mailSubject
            ? encodeURIComponent(props.mailSubject)
            : undefined,
          mailBody: props.mailBody
            ? encodeURIComponent(props.mailBody)
            : undefined,
        })}
        icon={{ component: WhatsappIcon, height: '25px' }}
        target="_blank"
        onClick={props.onClick}
      />
    </LayoutSwitch>
  );
};

export default InviteShareEmailButton;
